<p-toast />

<app-update-impact-dialog
  [visible]="showImpactDialog()"
  [impact]="impactResult()"
  [loading]="impactLoading()"
  (visibleChange)="showImpactDialog.set($event)"
  (proceed)="onImpactProceed()"
  (cancel)="onImpactCancel()"
/>

@if (loadingObject()) {
  <div class="flex justify-center items-center p-8" data-testid="wizard-loading">
    <p-progressSpinner />
  </div>
} @else {
  <div class="property-wizard" data-testid="property-wizard">
    <app-wizard-header
      [currentStep]="currentStep()"
      [title]="title()"
      [isViewMode]="isViewMode()"
      (cancel)="onCancel()"
    />

    <app-wizard-stepper
      [steps]="steps()"
      [currentStep]="currentStep()"
      [isViewMode]="isViewMode()"
      (stepClick)="goToStep($event)"
    />

    <!-- Bezpłatne pozycjonowanie: wskazówki "co uzupełnić, by wyświetlać się wyżej" (tryb edycji). -->
    @if (editObjectIdSignal(); as positioningObjectId) {
      <div class="wizard-positioning">
        <app-object-positioning-widget
          [objectId]="positioningObjectId"
          (navigate)="onPositioningNavigate($event)" />
      </div>
    }

    <main class="wizard-content">
      @if (loadingStep()) {
        <div class="flex justify-center items-center p-8">
          <p-progressSpinner />
        </div>
      } @else {
        @switch (currentStep()) {
          @case (0) {
            <app-step-basic-info (cancelled)="onCancel()" />
          }
          @case (1) {
            <app-step-unit-types
              (previous)="onStepChange()"
              (next)="onStepChange()"
            />
          }
          @case (2) {
            <app-step-pricing
              [isSubmitting]="submitting()"
              (previous)="onStepChange()"
              (submit)="onSubmit()"
            />
          }
        }
      }
    </main>
  </div>
}
